export default __webpack_public_path__ + "1ce4c998484f5db07019505dfe93cdf3.png";